export default __webpack_public_path__ + "static/media/BrainBreak cards62.7f2c9c26.png";